import axios from "axios";

const BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:5000/api";

const api = axios.create({ baseURL:BASE_URL, timeout:15000 });

api.interceptors.request.use((config) => {
  const stored = localStorage.getItem("sava_admin_user");
  if (stored) { try { const u=JSON.parse(stored); if(u?.token) config.headers.Authorization=`Bearer ${u.token}`; } catch {} }
  // Ensure FormData never has Content-Type forced so browser automatically sets multipart/form-data with boundary
  if (config.data instanceof FormData) {
    delete config.headers["Content-Type"];
  }
  return config;
});
api.interceptors.response.use(r=>r, err => {
  if (err.response?.status===401) {
    localStorage.removeItem("sava_admin_user");
    if (window.location.pathname.startsWith("/admin") && window.location.pathname!=="/admin") window.location.href="/admin";
  }
  return Promise.reject(err);
});

export const authAPI = {
  login: d => api.post("/auth/login", {
  username: d.username || d.email,
  password: d.password
}),
  me: () => api.get("/auth/me"),
  changePassword: d => api.put("/auth/change-password", d),
};

export const productsAPI = {
  getAll: p => api.get("/products", { params:p }),
  getBySlug: slug => api.get(`/products/${slug}`),
  create: d => api.post("/products", d),
  update: (id, d) => api.put(`/products/${id}`, d),
  delete: id => api.delete(`/products/${id}`),
};

export const servicesAPI = {
  getAll: () => api.get("/services"),
  getBySlug: slug => api.get(`/services/${slug}`),
  create: d => api.post("/services", d),
  update: (id, d) => api.put(`/services/${id}`, d),
  delete: id => api.delete(`/services/${id}`),
};

export const blogAPI = {
  getAll: p => api.get("/blog", { params:p }),
  getBySlug: slug => api.get(`/blog/${slug}`),
  getRecent: () => api.get("/blog/recent"),
  getAllAdmin: () => api.get("/blog/admin/all"),
  create: d => api.post("/blog", d),
  update: (id, d) => api.put(`/blog/${id}`, d),
  delete: id => api.delete(`/blog/${id}`),
};

export const blogCategoriesAPI = {
  getAll: () => api.get("/blog-categories"),
  create: d => api.post("/blog-categories", d),
  update: (id, d) => api.put(`/blog-categories/${id}`, d),
  delete: id => api.delete(`/blog-categories/${id}`),
};

export const galleryAPI = {
  getAll: p => api.get("/gallery", { params:p }),
  create: d => api.post("/gallery", d),
  update: (id, d) => api.put(`/gallery/${id}`, d),
  delete: id => api.delete(`/gallery/${id}`),
};

export const galleryCategoriesAPI = {
  getAll: () => api.get("/gallery-categories"),
  create: d => api.post("/gallery-categories", d),
  update: (id, d) => api.put(`/gallery-categories/${id}`, d),
  delete: id => api.delete(`/gallery-categories/${id}`),
};

export const contactAPI = {
  submit: formData => api.post("/contact/submit", formData, { headers:{ "Content-Type":"multipart/form-data" } }),
  getAll: p => api.get("/contact", { params:p }),
  updateStatus: (id, status) => api.patch(`/contact/${id}/status`, { status }),
  delete: id => api.delete(`/contact/${id}`),
};

export const bannersAPI = {
  get: page => api.get(`/banners/${page}`),
  update: (page, d) => api.put(`/banners/${page}`, d),
};

export const cmsAPI = {
  getPage: page => api.get(`/cms/${page}`),
  updatePage: (page, data) => api.put(`/cms/${page}`, data),
};

export const settingsAPI = {
  getAll: () => api.get("/settings"),
  update: d => api.put("/settings", d),
};

export const certificationsAPI = {
  getAll: () => api.get("/certifications"),
  create: d => api.post("/certifications", d),
  update: (id, d) => api.put(`/certifications/${id}`, d),
  delete: id => api.delete(`/certifications/${id}`),
};

export const dashboardAPI = {
  getStats: () => api.get("/dashboard/stats"),
};

export const brandsAPI = {
  getAll: () => api.get("/brands"),
  getAllAdmin: () => api.get("/brands/admin/all"),
  create: d => api.post("/brands", d),
  update: (id, d) => api.put(`/brands/${id}`, d),
  delete: id => api.delete(`/brands/${id}`),
  reorder: items => api.put("/brands/reorder", { items }),
};

export const searchAPI = {
  search: q => api.get("/search", { params: { q } }),
};

export const mediaAPI = {
  getAll: p => api.get("/media", { params: p }),
  delete: path => api.delete("/media", { data: { path } }),
};

export const uploadAPI = {
  single: (file, type="general", onProgress) => {
    const form = new FormData(); form.append("image", file);
    return api.post(`/upload/single?type=${type}`, form, {
      timeout: 60000,
      headers: { "Content-Type": undefined },
      onUploadProgress: (progressEvent) => {
        if (onProgress && progressEvent.total) {
          const percent = Math.round((progressEvent.loaded * 100) / progressEvent.total);
          onProgress(percent);
        }
      }
    });
  },
  multiple: (files, type="gallery", onProgress) => {
    const form = new FormData(); files.forEach(f=>form.append("images",f));
    return api.post(`/upload/multiple?type=${type}`, form, {
      timeout: 120000,
      headers: { "Content-Type": undefined },
      onUploadProgress: (progressEvent) => {
        if (onProgress && progressEvent.total) {
          const percent = Math.round((progressEvent.loaded * 100) / progressEvent.total);
          onProgress(percent);
        }
      }
    });
  },
  video: (file, type="videos", onProgress) => {
    const form = new FormData(); form.append("video", file);
    return api.post(`/upload/video?type=${type}`, form, {
      timeout: 300000, // 5 minutes timeout for large video uploads
      headers: { "Content-Type": undefined },
      onUploadProgress: (progressEvent) => {
        if (onProgress && progressEvent.total) {
          const percent = Math.round((progressEvent.loaded * 100) / progressEvent.total);
          onProgress(percent);
        }
      }
    });
  },
};

export default api;
